<template>
  <div class="audios">
    <div class="top">
      <back-button></back-button>
      <help-button></help-button>
    </div>
    <div class="content">
      <h1>Audio</h1>
      <plyr ref="plyrinstance" :options="{fullscreen: { enabled: true }, controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen']}">
        <!-- <audio :poster="audios[audio].cover.url"> -->
        <audio>
          <source :src="audios[audio].file" type="audio/mp4">
        </audio>
      </plyr>
      <h2 v-if="audios[audio].transcript">TRANSCRIPT</h2>
      <div v-if="audios[audio].transcript" v-html="audios[audio].transcript" class="textbox"></div>

<!--       <ul>
        <li v-for="audio, vid in audios">
          <router-link :to="link(exhibitid, vid)">Audio {{ vid }} </router-link>
        </li>
      </ul>
 -->    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

export default {
  name: 'audios',
  props: {
    exhibitslug: String,
    audio: { type: Number, default: 0 }
  },
  computed: {
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    audios () {
      return this.exhibitdata.audio_files
      // return [
      //   { src: 'https://3741e86e560ee00d9b76-c049b300f98180e8793541b364a98022.ssl.cf5.rackcdn.com/hpatcc-conf-v.mp4', format: 'mp4' },
      //   { src: 'https://06cebc4168b237fdea8b-616dc3977b041a7d2ce190d8a8629ee8.ssl.cf5.rackcdn.com/A_BAND\'S_VISIT.mp4', format: 'mp4' }
      // ]
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    }
  },
  methods: {
    link (id, audio) {
      return { name: 'audio', params: { exhibitid: id, audio: audio } }
    }
  },
  watch: {
    '$route.params.audio' (to, from) {
      let vidnum = parseInt(to)
      vidnum = isNaN(vidnum) ? 0 : vidnum
      this.$refs.plyrinstance.player.source = { type: 'audio', sources: [this.audios[vidnum]] }
    }
  }
}
</script>

<style lang="scss">
$plyr-color-main: #444;
@import 'plyr/src/sass/plyr.scss';
.plyr--audio .plyr__controls {
  background: #000;
  padding: 0px 10px;
}
</style>

<style lang="scss" scoped>
.audios {
  color: #000;
  height: 100%;
  overflow: hidden;
  background: url('../assets/backgrounds/heliconia.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}
.top {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.content {
  color: #000;
  background-color: white;
  padding: 20px;
  margin: 30px;
  margin-top: 0;
  flex: 1;
  overflow: auto;
}
</style>
